import { render, staticRenderFns } from "./ShopHeader.vue?vue&type=template&id=07f94c7a&scoped=true"
import script from "./ShopHeader.vue?vue&type=script&lang=js"
export * from "./ShopHeader.vue?vue&type=script&lang=js"
import style0 from "./ShopHeader.vue?vue&type=style&index=0&id=07f94c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f94c7a",
  null
  
)

export default component.exports